// extracted by mini-css-extract-plugin
export var closed = "_ft-1";
export var resizer = "_ft-0";